import type { TodoToolUseModel } from '../../../../data/projects/timeline/agent-todo/resolveTodoToolUse';
import { AgentTodoResultBlock } from './AgentTodoResultBlock';
import { PlanCard } from './PlanCard';

import type { JSX } from 'react';

interface TodoToolUseBlockProps {
  model: TodoToolUseModel;
}

export const TodoToolUseBlock = ({ model }: TodoToolUseBlockProps): JSX.Element => {
  if (model.kind === 'plan-card') {
    return (
      <PlanCard
        title={model.title}
        items={model.items}
        anchorId={model.anchorId}
        declined={model.declined}
        stopped={model.stopped}
      />
    );
  }

  return (
    <AgentTodoResultBlock
      status={model.status}
      title={model.title}
      subtitle={model.subtitle}
      items={model.items}
      error={model.error}
    />
  );
};
